'use client'

import { Typography } from '@/ui/atoms/typography/Typography'
import { cn } from '@/ui/utils/style'
import { ArrowRight, Coins, ShoppingBag, Wallet } from 'lucide-react'

const steps = [
  {
    number: '01',
    icon: Wallet,
    title: 'Connect & Verify',
    description: 'Link your wallet and complete a quick identity check. No credit check, no lengthy applications.',
  },
  {
    number: '02',
    icon: Coins,
    title: 'Collateralize',
    description: 'Your crypto stays on-chain. It backs your card while you keep your position.',
  },
  {
    number: '03',
    icon: ShoppingBag,
    title: 'Tap & Spend',
    description:
      'Tap anywhere Visa is accepted. Every swipe borrows in real time — no loading, no converting, no waiting.',
  },
]

export function CardHowItWorks() {
  return (
    <section id="how-it-works" className="py-12 lg:py-20">
      <div className="mx-auto max-w-6xl px-4 lg:px-8 sm:px-6">
        <div className="mb-10 text-center lg:mb-16">
          <Typography variant="h2" className="text-3xl lg:text-4xl" gradient>
            How It Works
          </Typography>
          <Typography variant="p" className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            Get started in three simple steps
          </Typography>
        </div>

        <div className="relative">
          <div className="grid gap-8 md:grid-cols-3">
            {steps.map((step, index) => (
              <div key={step.number} className="relative">
                <div className="flex flex-col items-center text-center">
                  <div
                    className={cn(
                      'flex h-16 w-16 items-center justify-center rounded-full',
                      'bg-gradient-to-br from-gradient-yellow to-gradient-green',
                      'mb-6 shadow-[0_0_30px_rgba(251,229,114,0.3)]',
                    )}
                  >
                    <step.icon className="h-6 w-6 text-black" />
                  </div>

                  <div
                    className={cn(
                      'mb-3 flex h-8 w-8 items-center justify-center rounded-full',
                      'bg-gradient-to-br from-gradient-yellow/20 to-gradient-green/20',
                      'font-semibold text-foreground text-sm',
                    )}
                  >
                    {step.number}
                  </div>

                  <Typography variant="h4" className="mb-2">
                    {step.title}
                  </Typography>
                  <Typography variant="p" className="max-w-xs text-muted-foreground text-sm">
                    {step.description}
                  </Typography>
                </div>

                {index < steps.length - 1 && (
                  <div className="absolute top-8 left-[calc(50%+2rem)] hidden w-[calc(100%-4rem)] md:block">
                    <div className="flex items-center justify-center">
                      <div className="h-[2px] w-full bg-gradient-to-r from-gradient-yellow/50 to-gradient-green/50" />
                      <ArrowRight className="-ml-2 h-4 w-4 text-gradient-yellow" />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
